<template>
  <div class="toast" v-show="visible">
    <p>{{ title || '提示' }}</p>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  visible: boolean;
  title?: string;
}>();


</script>

<style lang="scss">
.toast {
  position: absolute;
  top: 50%;
  left: 50%;
  width: fit-content;
  max-width: 90%;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 4px 8px;
  height: fit-content;
  transform: translate(-50%, -50%);
  color: #fff;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3000;
  font-size: 12px;
  p {
    color: #fff !important;
  }
}
</style>
